// Module
var code = "<div ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"> <i class=\"material-icons close-modal no-expand\" ng-class=\"{show: hover}\" ng-click=\"$ctrl.closeModal()\"> remove </i> <nets-chat-sms-session card=\"$ctrl.card\" context=\"modal\"></nets-chat-sms-session> </div>";
// Exports
export default code;